export const SET_SERVICE = 'setService'
